import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { PhoneInput } from "Components/Shared/Inputs/Form/PhoneInput";
import { useResource } from "Translations/Resources";
import { RESOURCES } from "./constants";
import type { usePhoneVerification } from "./usePhoneVerification";

type Props = {
  hasPhone: boolean;
  isSending: boolean;
  phoneForm: ReturnType<typeof usePhoneVerification>["phoneForm"];
  onSubmit: ReturnType<typeof usePhoneVerification>["handleSendCode"];
  description?: string;
  secondaryAction: React.ReactNode;
};

export const PhoneStep = ({
  hasPhone,
  isSending,
  phoneForm,
  onSubmit,
  description,
  secondaryAction,
}: Props) => {
  const { t } = useResource();

  return (
    <form onSubmit={phoneForm.handleSubmit(onSubmit)}>
      <DialogTitle>{t(RESOURCES.Title)}</DialogTitle>
      <DialogContent sx={{ pb: 0 }}>
        <DialogContentText mb={3}>
          {description ??
            t(
              hasPhone ? RESOURCES.DescriptionVerify : RESOURCES.DescriptionAdd,
            )}
        </DialogContentText>
        <PhoneInput
          name="phone"
          control={phoneForm.control}
          label={t(RESOURCES.PhoneLabel)}
        />
      </DialogContent>
      <DialogActions>
        {secondaryAction}
        <Button type="submit" variant="contained" disabled={isSending}>
          {t(RESOURCES.SendCode)}
        </Button>
      </DialogActions>
    </form>
  );
};
